import { VN_OFFSET_MS } from './time.js';
export const SITE_SECTIONS = ['about', 'activities', 'recruitment', 'competition'];
/** Icons an activity card may use. A fixed set: the page maps each to a component. */
export const ACTIVITY_ICONS = [
    'presentation', 'trophy', 'code', 'users', 'book', 'lightbulb', 'chart', 'handshake', 'calendar', 'rocket',
];
export const MAX_BENEFITS = 6;
export const MAX_AUDIENCE = 8;
/** Podium plus runners-up and special awards. */
export const MAX_PRIZES = 6;
/** How many of each the HBAAC page shows (Plan AN); the editor and the server both hold to it. */
export const HBAAC_LIMITS = {
    stats: 4,
    chips: 6,
    photos: 8,
    organizers: 4,
    patrons: 6,
    tiers: 8,
    logosPerTier: 10,
    judges: 8,
    finalists: 8,
    moments: 9,
};
/** The parts Plan AN added, empty: what content saved before them reads as. */
export const EMPTY_HBAAC_EXTRAS = {
    introTitle: '',
    intro: '',
    chips: [],
    keyVisual: '',
    registerPoster: '',
    recapPoster: '',
    stats: [],
    photos: [],
    organizers: [],
    patrons: [],
    sponsorTiers: [],
    judges: [],
    training: { image: '', title: '', body: '' },
    finalists: [],
    moments: [],
    albumUrl: '',
    prizeImage: '',
    contact: { mailbox: '', fanpageUrl: '', location: '' },
    registerNote: '',
    soloNote: '',
    rulesUrl: '',
    recapLength: '',
    closingNote: '',
    summaryUrl: '',
};
/**
 * What the site shows when nothing has been saved, and what the public page
 * falls back to if the content request fails. Also the seed of migration 0008.
 */
export const DEFAULT_SITE_CONTENT = {
    about: {
        stats: [
            { value: '120+', label: 'Thành viên' },
            { value: '2019', label: 'Năm thành lập' },
            { value: '30+', label: 'Dự án & hoạt động' },
        ],
    },
    activities: {
        items: [
            {
                icon: 'presentation',
                title: 'Workshop & Training',
                body: 'Chuỗi buổi học về SQL, Python, Power BI, tư duy phân tích, do thành viên và khách mời từ doanh nghiệp dẫn dắt.',
            },
            {
                icon: 'trophy',
                title: 'Cuộc thi HBAAC',
                body: 'Sân chơi phân tích kinh doanh thường niên do CLB tổ chức, mở cho sinh viên toàn quốc.',
            },
            {
                icon: 'code',
                title: 'Dự án thực tế',
                body: 'Nhóm nhỏ nhận bài toán thật từ doanh nghiệp hoặc cộng đồng, làm từ thu thập dữ liệu tới báo cáo cuối.',
            },
            {
                icon: 'users',
                title: 'Kết nối & Mentoring',
                body: 'Gắn kết các khoá, kết nối cựu thành viên đang làm trong ngành để định hướng nghề nghiệp.',
            },
        ],
    },
    recruitment: {
        enabled: false,
        season: '2026',
        intro: 'Không yêu cầu kinh nghiệm phân tích từ trước. Điều chúng tôi tìm là sự tò mò với dữ liệu và sẵn sàng làm việc cùng nhau.',
        applyUrl: 'https://forms.gle/',
        opensAt: '2026-09-01T00:00',
        closesAt: '2026-09-16T23:59',
        steps: [
            { title: 'Mở đơn đăng ký', at: '2026-09-01T00:00' },
            { title: 'Hạn nộp đơn', at: '2026-09-16T23:59' },
            { title: 'Phỏng vấn', at: '2026-09-19T08:00' },
            { title: 'Công bố kết quả', at: '2026-09-25T20:00' },
        ],
        benefits: [
            { title: 'Học phân tích dữ liệu bài bản', body: 'Workshop SQL, Python, Power BI và tư duy phân tích kinh doanh, học cùng anh chị khoá trên và khách mời từ doanh nghiệp.' },
            { title: 'Làm dự án thật', body: 'Nhóm nhỏ nhận bài toán từ doanh nghiệp hoặc cộng đồng, làm từ thu thập dữ liệu tới báo cáo cuối.' },
            { title: 'Tổ chức cuộc thi toàn quốc', body: 'Cùng tổ chức HBAAC cho sinh viên cả nước, rèn kỹ năng làm việc nhóm và quản lý dự án.' },
            { title: 'Kết nối và định hướng', body: 'Gặp cựu thành viên đang làm trong ngành dữ liệu, nghe chia sẻ về học tập và nghề nghiệp.' },
        ],
        audience: [
            'Sinh viên Đại học Bách khoa Hà Nội, mọi ngành, mọi khoá.',
            'Tò mò với dữ liệu và thích tìm câu trả lời từ những con số.',
            'Không cần kinh nghiệm phân tích từ trước, chỉ cần sẵn sàng học.',
            'Dành được vài buổi mỗi tuần cho hoạt động của CLB.',
        ],
        faq: [
            { q: 'Mình học ngành khác có tham gia được không?', a: 'Được. HBAC có thành viên từ nhiều ngành; điều quan trọng là bạn quan tâm tới dữ liệu và sẵn sàng học.' },
            { q: 'Có cần biết lập trình trước không?', a: 'Không bắt buộc. Thành viên mới được hướng dẫn từ đầu qua các buổi workshop của CLB.' },
            { q: 'Quy trình tuyển gồm những bước nào?', a: 'Nộp đơn online, phỏng vấn, rồi nhận kết quả. Các mốc cụ thể nằm ở phần Quy trình tuyển trên trang này.' },
            { q: 'Mỗi năm HBAC tuyển mấy đợt?', a: 'Mỗi năm một đợt, thường vào đầu năm học. Theo dõi Fanpage của HBAC để nhận thông báo sớm nhất.' },
        ],
    },
    competition: {
        season: '2026',
        tagline: 'Giải phân tích kinh doanh dành cho sinh viên toàn quốc',
        registerUrl: 'https://forms.gle/',
        opensAt: '2026-10-01T00:00',
        closesAt: '2026-10-19T23:59',
        highlights: [
            { title: 'Đề bài thật', body: 'Case do doanh nghiệp tài trợ cung cấp, có dữ liệu thật.', image: '', when: '', at: '' },
            { title: 'Thi theo đội', body: '3–4 thành viên, khuyến khích đội liên trường.', image: '', when: '', at: '' },
            { title: 'Được training', body: 'Buổi hướng dẫn miễn phí trước vòng loại.', image: '', when: '', at: '' },
        ],
        timeline: [
            { title: 'Mở đăng ký', at: '2026-10-01T00:00', detail: 'Đăng ký theo đội 3–4 người' },
            { title: 'Vòng loại', at: '2026-10-20T08:00', detail: 'Bài test trắc nghiệm và tình huống ngắn' },
            { title: 'Vòng bán kết', at: '2026-11-05T08:00', detail: 'Giải case thật từ doanh nghiệp tài trợ' },
            { title: 'Chung kết', at: '2026-11-25T08:00', detail: 'Trình bày trước hội đồng giám khảo' },
        ],
        prizes: [
            { place: 'Quán quân', value: '20.000.000đ' },
            { place: 'Á quân', value: '10.000.000đ' },
            { place: 'Quý quân', value: '5.000.000đ' },
        ],
        faq: [
            { q: 'Ai được tham gia?', a: 'Sinh viên đang theo học tại các trường đại học, cao đẳng trên toàn quốc. Không giới hạn ngành học.' },
            { q: 'Cần kiến thức gì trước?', a: 'Tư duy logic và sự quan tâm tới dữ liệu. Ban tổ chức có buổi training trước vòng loại cho tất cả thí sinh.' },
            { q: 'Đội thi bao nhiêu người?', a: 'Mỗi đội 3–4 thành viên, có thể đến từ nhiều trường khác nhau.' },
            { q: 'Chi phí tham gia?', a: 'Hoàn toàn miễn phí.' },
        ],
        recapVideoUrl: '',
        recapTitle: '',
        introTitle: '',
        intro: '',
        chips: [],
        keyVisual: '',
        registerPoster: '',
        recapPoster: '',
        stats: [],
        photos: [],
        organizers: [],
        patrons: [],
        sponsorTiers: [],
        judges: [],
        training: { image: '', title: '', body: '' },
        finalists: [],
        moments: [],
        albumUrl: '',
        prizeImage: '',
        contact: { mailbox: '', fanpageUrl: '', location: '' },
        registerNote: '',
        soloNote: '',
        rulesUrl: '',
        recapLength: '',
        closingNote: '',
        summaryUrl: '',
    },
};
// --- Time, always in Vietnam (UTC+7, no daylight saving) ---------------------
const WALL_TIME = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/;
/** Epoch ms for a Vietnam wall-clock time, or NaN when malformed or impossible (31/02). */
export function vnTime(s) {
    const m = WALL_TIME.exec(String(s ?? ''));
    if (!m)
        return NaN;
    const [y, mo, d, h, mi] = m.slice(1).map(Number);
    const utc = Date.UTC(y, mo - 1, d, h, mi);
    const back = new Date(utc);
    // Date.UTC rolls 31/02 over into March; refuse instead of silently moving the date.
    if (back.getUTCFullYear() !== y || back.getUTCMonth() !== mo - 1 || back.getUTCDate() !== d || h > 23 || mi > 59) {
        return NaN;
    }
    return utc - VN_OFFSET_MS;
}
/** 'dd/MM' of a wall-clock string, read from the string itself: no zone can shift it. */
export function vnDayMonth(s) {
    const m = WALL_TIME.exec(String(s ?? ''));
    return m ? `${m[3]}/${m[2]}` : '';
}
/** The current Vietnam wall-clock time as 'YYYY-MM-DDTHH:mm' (for editor defaults). */
export function vnNowString(now = Date.now()) {
    return new Date(now + VN_OFFSET_MS).toISOString().slice(0, 16);
}
/**
 * Where each milestone stands at `now`.
 *
 * A milestone whose time has come is reached. The latest reached one is
 * 'current' (the phase we are in) while a later milestone is still ahead;
 * once the final milestone has passed, everything is 'done'.
 */
export function timelineState(steps, now) {
    const reached = steps.map((s) => vnTime(s.at) <= now);
    const lastReached = reached.lastIndexOf(true);
    const allReached = lastReached === steps.length - 1;
    return steps.map((_, i) => {
        if (!reached[i])
            return 'upcoming';
        return i === lastReached && !allReached ? 'current' : 'done';
    });
}
export function registrationState(opensAt, closesAt, now) {
    if (now < vnTime(opensAt))
        return 'before';
    if (now <= vnTime(closesAt))
        return 'open';
    return 'closed';
}
//# sourceMappingURL=site-content.js.map